const { get } = require('lodash');

function getActiveOrg(user) {
  let activeOrg = get(user['https://vrpatients.com/app_metadata'], 'activeOrg');
  const groups = user['https://vrpatients.com/groups'];
  // The activeOrg might not exist in the current environment
  if (!activeOrg || !groups.find(groupId => groupId === activeOrg)) {
    // Fall back to 0th group
    activeOrg = groups && groups.length ? groups[0] : undefined;
  }
  return activeOrg;
}

module.exports = getActiveOrg;
